import React from 'react'
import AdminManagement from './index'
import { GenericForm } from './GenericForm'
import { colors, buildProvinceSelectOptions } from '../../const'
import InstitutionNodes from './InstitutionNodes'
import { Building2 } from 'lucide-react'

const InstitutionsManagement = () => {
  const renderInstitution = (item) => (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
      <Building2 size={30} color={colors.primary} style={{ marginRight: '10px' }} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '10px 0' }}>
        <span style={{ fontWeight: 'bold', fontSize: '1.1rem', color: colors.primary }}>{item.nombre}</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ color: colors.textSecondary }}>
            {item.calle || ''} {item.numero || ''}
          </span>
        </div>
        <span style={{ color: colors.textSecondary, fontSize: '0.9rem' }}>
          {item.localidad ? `${item.localidad}, ` : ''}{item.provincia || ''}
        </span>
      </div>
    </div>
  )

  const columns = [
    { key: 'info', label: '', render: renderInstitution }
  ]

  const buildFormFields = (initialData) => [
    { key: 'nombre', label: 'Nombre', required: true, fullWidth: true },
    { key: 'email', label: 'Email', type: 'email', required: true },
    { key: 'calle', label: 'Calle', required: true },
    { key: 'numero', label: 'Número', type: 'number', required: true },
    { key: 'localidad', label: 'Localidad', required: true },
    {
      key: 'provincia',
      label: 'Provincia',
      type: 'select',
      required: true,
      options: buildProvinceSelectOptions(initialData?.provincia)
    },
    { key: 'telefono', label: 'Teléfono', required: true }
  ]

  const FormComponent = (props) => (
    <GenericForm {...props} fields={buildFormFields(props.initialData)} title='Institución' />
  )

  return (
    <AdminManagement
      entityType='Instituciones'
      headerSubtitle='Desde acá podés administrar instituciones que utilizan Retinar, y agregar, modificar o eliminar sus nodos de captura.'
      HeaderIcon={Building2}
      columns={columns}
      searchKeys={['nombre', 'email', 'calle', 'localidad', 'provincia', 'telefono']}
      apiEndpoint='instituciones'
      FormComponent={FormComponent}
      gridTemplateColumns='1fr 100px'
      renderRowDetail={(institution) => <InstitutionNodes institution={institution} />}
      singularEntityName='Institución'
    />
  )
}

export default InstitutionsManagement
